// extracted by mini-css-extract-plugin
export default {"emptyListContainer":"emptyList_emptyListContainer__ir3G8","noResultsIcon":"emptyList_noResultsIcon__EB11v","recommendedLink":"emptyList_recommendedLink__eSxHW"};